import { TbLink } from '@website-builder/model/domain/link/tb-link';
import { LinkType } from '@website-builder/model/domain/link/link-type.enum';
import { LinkTarget } from '@website-builder/model/domain/link/link-target.enum';
import { makeEntityId } from '@website-builder/util/make-widget-id.utility';
import { EntityIdPrefix } from '@website-builder/model/domain/entity-id-prefix.enum';

export class SocialElement {
  id = makeEntityId(EntityIdPrefix.WIDGET_ELEMENT);
  link = new TbLink();
  icon: string;

  constructor(link?: string, icon?: string) {
    this.link.type = LinkType.Website;
    this.link.url = link;
    this.link.target = LinkTarget.NewTab;
    this.icon = icon;
  }

  static normalizeInPlace(element: SocialElement): SocialElement {
    const pureElement = new SocialElement();

    element.link = TbLink.normalizeInPlace(element.link ?? pureElement.link);
    element.icon = element.icon ?? pureElement.icon;

    return element;
  }
}
